/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MediaPipelineStageFromJSON, MediaPipelineStageToJSON, } from './MediaPipelineStage';
import { StaffMediaProblemKindFromJSON, StaffMediaProblemKindToJSON, } from './StaffMediaProblemKind';
/**
 * Check if a given object implements the StaffMediaProblem interface.
 */
export function instanceOfStaffMediaProblem(value) {
    let isInstance = true;
    return isInstance;
}
export function StaffMediaProblemFromJSON(json) {
    return StaffMediaProblemFromJSONTyped(json, false);
}
export function StaffMediaProblemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fileId': !exists(json, 'fileId') ? undefined : json['fileId'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'incidentReportId': !exists(json, 'incidentReportId') ? undefined : json['incidentReportId'],
        'kind': !exists(json, 'kind') ? undefined : StaffMediaProblemKindFromJSON(json['kind']),
        'stage': !exists(json, 'stage') ? undefined : MediaPipelineStageFromJSON(json['stage']),
        'occurredAt': !exists(json, 'occurredAt') ? undefined : (new Date(json['occurredAt'])),
    };
}
export function StaffMediaProblemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fileId': value.fileId,
        'fileName': value.fileName,
        'incidentReportId': value.incidentReportId,
        'kind': StaffMediaProblemKindToJSON(value.kind),
        'stage': MediaPipelineStageToJSON(value.stage),
        'occurredAt': value.occurredAt === undefined ? undefined : (value.occurredAt.toISOString()),
    };
}
